/**
 * ProductsProvider
 * Contain most logic handing with Omnitech Api
 */

import React from 'react'
import ProductsContext from './products-context'
import { fetchProduct } from './products-api'

export default function ProductsProvider({ children }) {

  const state = {
    fetchProduct
  }
  return (
    <ProductsContext.Provider value={state}>
      {children}
    </ProductsContext.Provider>
  )
}
